export default __webpack_public_path__ + "static/media/partners7.8e1035cc.png";